import React from "react";
import "./App.scss";
import Header from "./components/partials/Header";
import { Switch, Route, Redirect } from "react-router-dom";
import Home from "./components/Home";
import About from "./components/About";
import Contact from "./components/Contact/Contact";
import Projects from "./components/Projects";
import { selectIsAdminAuthenticated, useAppSelector } from "./store";
import Notification from "./components/partials/Notification";
import AdminLogin from "./components/AdminLogin";
import Admin from "./components/Admin";
import AdminRegister from "./components/AdminRegister";
import NotFoundGeneric from "./components/NotFoundGeneric";
import { AnimatePresence, Variants } from "framer-motion";

export const pageVariants: Variants = {
  initial: { x: "-5%", opacity: 0 },
  in: { x: 0, opacity: 1 },
  out: { x: "-100%", opacity: 0 },
};

function App() {
  const isAdminAuthenticated = useAppSelector(selectIsAdminAuthenticated);
  // console.log(`auth ${isAdminAuthenticated}`);

  return (
    <div className="App">
      <Header />
      <AnimatePresence exitBeforeEnter>
        <Switch>
          <Route path="/about" exact>
            <About />
          </Route>
          <Route path="/contact" exact>
            <Contact />
          </Route>
          <Route path="/projects" exact>
            <Projects />
          </Route>
          <Route path="/admin/register" exact>
            <AdminRegister />
          </Route>
          <Route path="/admin/login" exact>
            {(isAdminAuthenticated && <Redirect to="/admin" />) || (
              <AdminLogin />
            )}
          </Route>
          <Route path="/admin" exact>
            {(isAdminAuthenticated && <Admin />) || (
              <Redirect to="/admin/login" />
            )}
          </Route>
          <Route path="/" exact>
            <Home />
          </Route>
          <Route path="*">
            <NotFoundGeneric />
          </Route>
        </Switch>
      </AnimatePresence>
      <Notification />
    </div>
  );
}

export default App;
